import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import InfluencerForm from '@/components/InfluencerForm';
import Footer from '@/components/Footer';

// /influencer-kayit sayfasi: form ile minimal sayfa.
// Eski inline KVKK metni kaldirildi (cifte metin sorunu); tek gecerli KVKK /gizlilik-politikasi sayfasinda.
const InfluencerFormPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    // Sticky footer pattern: flex-col + main flex-1 + Footer en altta sabit kalir.
    // pt-12 (48px) + InfluencerForm section py-20 (80px) = 128px ust bosluk → AboutPage pt-32 ile esit hizalama.
    // Navbar h-24 (96px, fixed) altinda 32px acik spacing kalir.
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Navbar />
      <main className="flex-1 pt-12">
        <InfluencerForm />
      </main>
      <Footer />
    </div>
  );
};

export default InfluencerFormPage;
